import { action, observable, makeObservable } from 'mobx';
import { BaasicApp } from 'baasic-sdk-reactjs';
import { baasicOptions } from 'common/infrastructure';

class ApplicationStore {
	constructor(rootStore) {
        makeObservable(this);
        this.rootStore = rootStore;
    }

	@observable apps = observable.map();
	@observable applicationIdentifier = observable.box(null);
	app = null;
	currentOrganization = {};
	organizationType = '';

	@action setApp(app) {
		this.app = app;
		this.applicationIdentifier.set(app && app.baasic ? app.baasic.getApiKey() : null);
	}

	@action create(application, config = {}) {
		const { apiKey: apiKey } = application;

		let app = null;
		if (!this.apps.has(apiKey)) {
			const options = {
				...baasicOptions,
				...config,
			};

			app = new BaasicApp(apiKey, {
				...options,
			});

			this.apps.set(apiKey, app);
		} else {
			app = this.apps.get(apiKey);
		}

		this.setApp({ baasic: app });

		return app;
	}

	@action setOrganization(organization) {
		if (organization != null) {
			this.currentOrganization = organization;
			this.organizationType = organization.organizationType.abrv
		}
	}
}

export default ApplicationStore;
